import axios from 'axios';
import api from './api';

export default {
    printProfileKanbanLabel(profileId, preferredPrinter) {
        return axios.post('/export/printProfileKanbanLabel/', {
            profileId,
            preferredPrinter,
        });
    },
    printProfileLabel(profileId, preferredPrinter) {
        return axios.post('/export/printProfileLabel/', {
            profileId,
            preferredPrinter,
        });
    },
    printKanbanWithFilter(payload) {
        return axios.post('/export/printKanbanWithFilter/', payload);
    },
    printWindowLabel(productId, preferredPrinter) {
        return axios.post('/export/printWindowLabel/', {
            productId,
            preferredPrinter,
        });
    },
    printProductionLabel(productId, preferredPrinter) {
        return axios.post('/export/printProductionLabel/', {
            productId,
            preferredPrinter,
        });
    },
    exportProductionLabel(productId) {
        return axios.post('/export/exportProductionLabel/', {
            productId,
        }, {
            responseType: 'blob',
        });
    },
    printProductionLabelsForOrder(orderId, preferredPrinter) {
        return axios.post('/export/printProductionLabelsForOrder/', {
            orderId,
            preferredPrinter,
        });
    },
    exportProductionLabelsForOrder(orderId) {
        return axios.post('/export/exportProductionLabelsForOrder/', {
            orderId,
        });
    },
    printRetourLabel(productId, preferredPrinter) {
        return axios.post('/export/printRetourLabel/', {
            productId,
            preferredPrinter,
        });
    },
    printTransportLabel(productId, preferredPrinter) {
        return axios.post('/export/printTransportLabel/', {
            productId,
            preferredPrinter,
        });
    },
    printCNCBarcodeLabelForProduct(productId, preferredPrinter) {
        return axios.post('/export/printCNCBarcodeLabelForProduct/', {
            productId,
            preferredPrinter,
        });
    },
    printPaintListProductionLabels(paintlistId, preferredPrinter) {
        return axios.post('/export/printPaintListProductionLabels/', {
            paintlistId,
            preferredPrinter,
        });
    },
    exportPaintListProductionLabels(paintlistId) {
        return axios.post('/export/exportPaintListProductionLabels/', {
            paintlistId,
        });
    },
    printProductAndCncLabelsForOptimizedPaintlist(
        optimizedPaintlistId,
        preferredPrinter
    ) {
        return axios.post(
            '/export/printProductAndCncLabelsForOptimizedPaintlist/',
            { optimizedPaintlistId, preferredPrinter }
        );
    },
    printWindowLabelsForOptimizedPaintlist(
        optimizedPaintlistId,
        preferredPrinter
    ) {
        return axios.post('/export/printWindowLabelsForOptimizedPaintlist/', {
            optimizedPaintlistId,
            preferredPrinter,
        });
    },
    printWindowLabelsForOptimizedPaintlistRecord(
        optimizedPaintlistRecordId,
        preferredPrinter
    ) {
        return axios.post(
            '/export/printWindowLabelsForOptimizedPaintlistRecord/',
            { optimizedPaintlistRecordId, preferredPrinter }
        );
    },
    printProductLabelsForOptimizedPaintlist(
        optimizedPaintlistId,
        preferredPrinter,
        withCeLabel = false
    ) {
        return axios.post('/export/printProductLabelsForOptimizedPaintlist/', {
            optimizedPaintlistId,
            preferredPrinter,
            withCeLabel,
        });
    },
    printProductLabelsForOptimizedPaintlistRecord(
        optimizedPaintlistRecordId,
        preferredPrinter,
        withCeLabel
    ) {
        return axios.post(
            '/export/printProductLabelsForOptimizedPaintlistRecord/',
            {
                optimizedPaintlistRecordId,
                preferredPrinter,
                withCeLabel,
            }
        );
    },
    printProductIdentificationLabel(productId, preferredPrinter) {
        return axios.post('/export/printProductIdentificationLabel/', {
            productId,
            preferredPrinter,
        });
    },
    exportProductIdentificationLabel(productId) {
        return axios.post(
            '/export/exportProductIdentificationLabel/',
            {
                productId,
            },
            {
                responseType: 'blob',
            }
        );
    },
    printTextLabel(text, preferredPrinter) {
        return axios.post('/export/printTextLabel/', {
            text,
            preferredPrinter,
        });
    },
    exportStockProfileImages(payload) {
        return api.createGetUrl('/export/exportStockProfileImages/', payload);
    },
    requestProductExport(year) {
        return axios.post('[API]/product-exports', { year });
    },
    checkProductExport(id) {
        return axios.get(`[API]/product-exports/${id}`);
    },
    downloadProductExport(id) {
        return axios.get(`[API]/product-exports/${id}/download`, { responseType: 'blob' });
    },
};
